export default {
    bind (el, binding) {
        let timer = null
        const delay = binding.arg || 1000 // 默认防抖延迟时间为 2000 毫秒

        const handleClick = (...args) => {
            if (timer) clearTimeout(timer)
            timer = setTimeout(() => {
                if (typeof binding.value === 'function') {
                    // 处理带参数或不带参数的函数
                    binding.value(...args)
                } else {
                    console.error('V-debounce期望得到一个函数，但得到了:', binding.value)
                }
            }, delay)
        }

        // 绑定事件处理函数
        el.__debounceHandler__ = handleClick
        el.addEventListener('click', handleClick)
    },
    unbind (el) {
        // 当元素销毁时，移除事件监听
        el.removeEventListener('click', el.__debounceHandler__)
        delete el.__debounceHandler__
    },
    componentUpdated (el, binding) {
        // 当元素重新渲染或更新时，移除旧的事件监听并绑定新的事件监听
        el.removeEventListener('click', el.__debounceHandler__)

        const delay = binding.arg || 2000
        const handleClick = (...args) => {
            if (el.__timer__) clearTimeout(el.__timer__)
            el.__timer__ = setTimeout(() => {
                if (typeof binding.value === 'function') {
                    binding.value(...args)
                } else {
                    console.error('V-debounce期望得到一个函数，但得到了:', binding.value)
                }
            }, delay)
        }

        // 更新时重新绑定事件处理函数
        el.__debounceHandler__ = handleClick
        el.addEventListener('click', handleClick)
    }
}